import { Card, Flex, theme, Typography } from 'antd';
import React, { type ReactNode, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './login.form';
import { AuthContext } from '../../contexts/auth-context-provider';
// import bg from '../../images/background.jpg';

const LoginPage = (): ReactNode => {
  const { token } = theme.useToken();
  const { isAuthenticated, returnToApp } = useContext(AuthContext);
  const navigate = useNavigate();

  if (isAuthenticated) {
    return returnToApp;
  }
  return (
    // <div style={{ background: `url('${bg}')`, backgroundSize: 'cover' }}>
    <div>
      <Flex
        align="center"
        justify="center"
        style={{
          width: '100vw',
          height: '100vh',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
        }}
        vertical
      >
        <Typography.Title level={2} style={{ marginBottom: 50, fontWeight: 'bold' }}>
          <Typography.Text style={{ fontWeight: 400 }}>Welcome to</Typography.Text>
          <br />
          Hoffman House Catering
        </Typography.Title>
        <Card
          variant="outlined"
          styles={{
            body: { padding: token.paddingLG },
          }}
        >
          <Flex gap="large" vertical>
            <Flex vertical>
              <Typography.Title level={3} style={{ marginBlock: 0 }}>
                Login
              </Typography.Title>
              <Typography.Text disabled>
                Enter your email below to login to your account
              </Typography.Text>
            </Flex>
            <LoginForm
              onSuccess={(email) => {
                navigate('/verify?email=' + encodeURIComponent(email));
              }}
            />
          </Flex>
        </Card>
      </Flex>
    </div>
  );
};

export default LoginPage;
